import { Box, Container, Stack, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { customStyles } from "./index.styles";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import InsertEmoticonOutlinedIcon from "@mui/icons-material/InsertEmoticonOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import FeatureCards from "../../../shared/components/FeatureCards";
import { colorPalette } from "../../../shared/utils/constants";

interface Props {
  id: string;
}

const features = [
  {
    icon: <StarBorderOutlinedIcon sx={customStyles.icon} />,
    text: "Satisfactory Work",
  },
  {
    icon: <InsertEmoticonOutlinedIcon sx={customStyles.icon} />,
    text: "Happy Customers",
  },
  {
    icon: <GroupsOutlinedIcon sx={customStyles.icon} />,
    text: "Professional Team",
  },
  {
    icon: <AssignmentOutlinedIcon sx={customStyles.icon} />,
    text: "Flexible contracts",
  },
];

const AboutUs = ({ id }: Props) => (
  <Box
    id={id}
    sx={{ background: colorPalette.sectionTitle, my: 4, pt: 2, pb: 8 }}
  >
    <Container maxWidth="md">
      <Box id={id} mt={6} mb={4} sx={{ xs: 0, md: 12 }}>
        <Typography variant="h3" sx={customStyles.text}>
          About us
        </Typography>
      </Box>

      <Container maxWidth="xl" sx={customStyles.card}>
        <Stack spacing={2} alignItems="center">
          <Typography
            color="white"
            fontSize={18}
            textAlign="center"
            sx={customStyles.descriptionText}
          >
            Welcome to Radiant Property Management, where cleanliness meets
            convenience. We are a dedicated team of professionals committed to
            delivering top-notch cleaning services tailored to meet your needs.
            With years of experience in the industry, we understand the
            importance of a clean and healthy environment for your businesses.
          </Typography>

          <Typography
            color="white"
            fontSize={18}
            textAlign="center"
            sx={customStyles.descriptionText}
          >
            We specialise in professional commercial cleaning and property
            services in Melbourne, offering customized services for a wide range
            of businesses, including Offices, Childcare facilities, Hotels,
            Gyms, Retail stores, and all type of Commercial cleaning.
          </Typography>

          <FeatureCards features={features} />

          <Button
            component={Link}
            to="/about"
            variant="text"
            sx={customStyles.seeMoreButton}
          >
            Read More →
          </Button>
        </Stack>
      </Container>

      <Container maxWidth="xl" sx={customStyles.textCard}>
        <Stack spacing={2} mt={2}>
          <Typography
            textAlign="center"
            color="white"
            sx={customStyles.descriptionText}
          >
            Welcome to Radiant Property Management, where cleanliness meets
            convenience. We are a dedicated team of professionals committed to
            delivering top-notch cleaning services tailored to meet your needs.
            With years of experience in the industry, we understand the
            importance of a clean and healthy environment for your businesses.
          </Typography>

          <Typography
            textAlign="center"
            color="white"
            sx={customStyles.descriptionText}
          >
            We specialise in professional commercial cleaning and property
            services in Melbourne, offering customized services for a wide range
            of businesses, including offices, childcare facilities, hotels,
            gyms, retail stores, and all type of commercial cleaning.
          </Typography>

          <FeatureCards features={features} />

          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              component={Link}
              to="/about"
              variant="text"
              sx={customStyles.seeMoreButton}
            >
              Read More →
            </Button>
          </Box>
        </Stack>
      </Container>
    </Container>
  </Box>
);

export default AboutUs;
